import { useState } from 'react'

interface Position {
  x: number
  y: number
}

interface UseFlyingAnimationReturn {
  selectedImageUrl: string | null
  clickPosition: Position | null
  handleSelect: (e: React.MouseEvent, url: string) => void
  resetAnimation: () => void
}

export const useFlyingAnimation = (): UseFlyingAnimationReturn => {
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null)
  const [clickPosition, setClickPosition] = useState<Position | null>(null)

  const handleSelect = (e: React.MouseEvent, url: string) => {
    const rect = (e.target as HTMLElement).getBoundingClientRect()
    setClickPosition({
      x: rect.left,
      y: rect.top,
    })
    setSelectedImageUrl(url)
  }

  const resetAnimation = () => {
    setSelectedImageUrl(null)
    setClickPosition(null)
  }

  return {
    selectedImageUrl,
    clickPosition,
    handleSelect,
    resetAnimation,
  }
}
